import chatAiIcon from "@/assets/figma/chat-workflow/chat-ai.svg";

export function ConversationHydrationSkeleton() {
  return (
    <section
      aria-busy="true"
      className="merry-conversation merry-conversation--skeleton"
      data-figma-source-node-id="631:113391"
    >
      <span className="sr-only" role="status">
        正在恢复对话
      </span>
      <div className="merry-conversation-skeleton__scroll">
        <div className="merry-conversation-skeleton__user" />
        <AssistantResponseSkeleton />
      </div>
    </section>
  );
}

export function AssistantResponseSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="conversation-assistant-skeleton"
      data-figma-source-node-id="631:113391"
    >
      <div className="conversation-assistant-skeleton__identity">
        <img alt="" src={chatAiIcon} />
        <strong>Merry</strong>
      </div>
      <div className="conversation-assistant-skeleton__lines">
        <span />
        <span />
      </div>
      <div className="conversation-assistant-skeleton__cards">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
